module.exports = __webpack_public_path__ + "static/media/swimming.f40afd2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/swimming.svg
// module id = 263
// module chunks = 0